import { render, staticRenderFns } from "./BcModalOverride.vue?vue&type=template&id=aa1bd010"
import script from "./BcModalOverride.vue?vue&type=script&lang=js"
export * from "./BcModalOverride.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports